export default {
  getBrand: (state) => state.brand,
};
